var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6708 12.7739L19.1466 12.7739C19.3043 12.7615 19.4516 12.689 19.5591 12.5709C19.6666 12.4528 19.7263 12.2978 19.7263 12.1368C19.7263 11.9759 19.6666 11.8209 19.5591 11.7028C19.4516 11.5847 19.3043 11.5122 19.1466 11.4998L12.6708 11.4998L12.6752 4.90811C12.663 4.74766 12.5918 4.59781 12.4757 4.4885C12.3596 4.37918 12.2072 4.31846 12.049 4.31846C11.8908 4.31846 11.7384 4.37918 11.6223 4.4885C11.5062 4.59781 11.4349 4.74766 11.4227 4.90811L11.4183 11.4998L4.93806 11.4953C4.85175 11.4885 4.76499 11.4999 4.68323 11.5289C4.60146 11.5578 4.52646 11.6036 4.46293 11.6634C4.3994 11.7232 4.34871 11.7958 4.31404 11.8765C4.27938 11.9572 4.26148 12.0443 4.26148 12.1323C4.26148 12.2204 4.27938 12.3075 4.31404 12.3882C4.34871 12.4689 4.3994 12.5414 4.46293 12.6012C4.52646 12.661 4.60146 12.7069 4.68323 12.7358C4.76499 12.7647 4.85175 12.7761 4.93806 12.7694L11.4183 12.7739L11.4183 19.3611C11.4305 19.5215 11.5018 19.6714 11.6179 19.7807C11.734 19.89 11.8863 19.9507 12.0445 19.9507C12.2027 19.9507 12.3551 19.89 12.4712 19.7807C12.5873 19.6714 12.6586 19.5215 12.6708 19.3611L12.6708 12.7739Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.03125,
    y1: 1.6875,
    x2: 23,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CA21"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.87d38e2e.svg";
export { ForwardRef as ReactComponent };